import { render, staticRenderFns } from "./Hygienist.vue?vue&type=template&id=1aaf8ace&scoped=true"
import script from "./Hygienist.vue?vue&type=script&lang=ts"
export * from "./Hygienist.vue?vue&type=script&lang=ts"
import style0 from "./Hygienist.vue?vue&type=style&index=0&id=1aaf8ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf8ace",
  null
  
)

export default component.exports